import { render, staticRenderFns } from "./TimestampInput.vue?vue&type=template&id=5f85b21d&scoped=true"
import script from "./TimestampInput.vue?vue&type=script&lang=js"
export * from "./TimestampInput.vue?vue&type=script&lang=js"
import style0 from "./TimestampInput.vue?vue&type=style&index=0&id=5f85b21d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85b21d",
  null
  
)

export default component.exports